// Wizard modal pages
export const WIZARD_PAGE_ONBOARDING_PROJECT_DETAILS_SOURCE_NAME =
    "onboardingProjectDetails";
export const WIZARD_PAGE_ONBOARDING_WORK_TYPES_SOURCE_NAME =
    "onboardingWorkTypes";
export const WIZARD_PAGE_ONBOARDING_BOARD_COLUMNS_SOURCE_NAME =
    "onboardingBoardColumns";
export const WIZARD_PAGE_ONBOARDING_INVITE_SOURCE_NAME = "onboardingInvitePage";
// Wizard board column limits
export const MIN_COLUMNS_LEN = 3;
export const MAX_COLUMNS_LEN = 5;
export const MAX_INPUT_LENGTH = 30;

export const ANALYTICS_PREFIX = "onboardingWizard";
